import PatientTakesMedicine from "../questions/PatientTakesMedicine"
import PatientAgeIsAtLeast from "../questions/PatientAgeIsAtLeast"
import PatientHasPreCondition, {
    PatientPreConditions
} from "../questions/PatientHasPreCondition"
import PatientTakesAtLeastNumberOfAntidepressants from "../questions/PatientTakesAtLeastNumberOfAntidepressants"
import {
    MedicationGroups,
    MedicationIndicators,
    medSearch,
    SingleMedicationEntries
} from "pokal_api"
import QuestionCreator from "../abstract/QuestionCreator"
import MedicationAnswer from "../abstract/MedicationAnswer"
import BoolQuestionAnswerStrategy from "../abstract/BoolQuestionAnswerStrategy"
import PatientHasSFQValue, {
    PatientSFQValues
} from "../questions/PatientHasSFQValue"

const SECTION_1: QuestionCreator = (input) =>
    PatientTakesMedicine(
        medSearch()
            .andGroup(MedicationGroups.TCA, 50)
            .and(SingleMedicationEntries.TRANYLCYPROMIN)
            .and(SingleMedicationEntries.TRANYLCYPROMIN_UND_PSYCHOLEPTIKA)
            .andGroup(MedicationGroups.SNRI),
        new MedicationAnswer("Ja").followedBy(
            //Hat der Patient/die Patientin eine bekannte Herzinsuffizienz?
            PatientHasPreCondition(
                PatientPreConditions.v4,
                new MedicationAnswer("Ja").triggers([
                    MedicationIndicators.RISK_OF_UNWANTED_KARDIOVASKULAER_EFFECTS_1
                ])
            )(input)
        )
    )(input)

const SECTION_2: QuestionCreator = (input) =>
    PatientTakesMedicine(
        medSearch().andGroup(MedicationGroups.TCA, 50),
        new MedicationAnswer("Ja").followedBy(
            //Hat der Patient eine bekannte Ischämische Herzkrankheit (z.B. KHK, Angina pectoris, Myokardinfarkt)?
            PatientHasPreCondition(
                PatientPreConditions.v7,
                new MedicationAnswer("Ja").triggers([
                    MedicationIndicators.RISK_OF_UNWANTED_KARDIOVASKULAER_EFFECTS_2
                ])
            )(input)
        )
    )(input)

const SECTION_3: QuestionCreator = (input) =>
    PatientTakesMedicine(
        medSearch()
            .and(SingleMedicationEntries.CITALOPRAM, 20)
            .and(SingleMedicationEntries.ESCITALOPRAM, 10),
        new MedicationAnswer("Ja").followedBy(
            PatientAgeIsAtLeast(
                65,
                new MedicationAnswer("Ja").triggers([
                    MedicationIndicators.RISK_OF_QT_TIME_LONGING
                ])
            )(input)
        )
    )(input)

const SECTION_4: QuestionCreator = (input) =>
    PatientTakesMedicine(
        medSearch()
            .and(SingleMedicationEntries.CITALOPRAM)
            .and(SingleMedicationEntries.ESCITALOPRAM),
        new MedicationAnswer("Ja").followedBy(
            //Der Patient / die Patientin hat(te) eine bekannte QT-Verlängerung oder entspr. Risikofaktoren
            // (Herzmuskelhypertrophie, Bradyarrhythmie, ständige Neigung zu Hypokaliämie, etc.)?
            PatientHasPreCondition(
                PatientPreConditions.v2,
                new MedicationAnswer("Ja").triggers([
                    MedicationIndicators.RISK_OF_QTC_TIME_LONGING
                ])
            )(input)
        )
    )(input)

const SECTION_5: QuestionCreator = (input) =>
    PatientTakesMedicine(
        medSearch()
            // .and(SingleMedicationEntries.CITALOPRAM)
            // .and(SingleMedicationEntries.ESCITALOPRAM)
            // .and(SingleMedicationEntries.AMITRIPTYLIN)
            // .and(SingleMedicationEntries.CLOMIPRAMIN)
            // .and(SingleMedicationEntries.DOXEPIN_2)
            // .and(SingleMedicationEntries.IMIPRAMIN)
            // .and(SingleMedicationEntries.NORTRIPTYLIN)
            // .and(SingleMedicationEntries.TRIMIPRAMIN)
            // .and(SingleMedicationEntries.MAPROTILIN)
            // .and(SingleMedicationEntries.MIRTAZAPIN)
            // .and(SingleMedicationEntries.MIANSERIN)
            .andGroup(MedicationGroups.RISK_OF_TORSADE_DE_POINTES_ARRHYTHMIA),
        new MedicationAnswer("Ja").followedBy(
            PatientTakesMedicine(
                medSearch()
                    .and(SingleMedicationEntries.CITALOPRAM, 0)
                    .and(SingleMedicationEntries.ESCITALOPRAM, 0)
                    .and(SingleMedicationEntries.AMITRIPTYLIN, 50)
                    .and(SingleMedicationEntries.CLOMIPRAMIN, 50)
                    .and(SingleMedicationEntries.DOXEPIN_2, 50)
                    .and(SingleMedicationEntries.IMIPRAMIN, 50)
                    .and(SingleMedicationEntries.NORTRIPTYLIN, 50)
                    .and(SingleMedicationEntries.TRIMIPRAMIN, 50)
                    .and(SingleMedicationEntries.MAPROTILIN, 0)
                    .and(SingleMedicationEntries.MIRTAZAPIN, 50)
                    .and(SingleMedicationEntries.MIANSERIN, 0),
                new MedicationAnswer("Ja").triggers([
                    MedicationIndicators.RISK_OF_UNWANTED_KARDIOVASKULAER_EFFECTS_5
                ])
            )(input)
        ),
        { strategy: BoolQuestionAnswerStrategy.ON_YES },
        2
    )(input)





const SECTION_6: QuestionCreator = (input) =>
    PatientTakesMedicine(
        medSearch()
            .andGroup(MedicationGroups.BUPROPION_DRUGS)
            .and(SingleMedicationEntries.TRANYLCYPROMIN)
            .and(SingleMedicationEntries.TRANYLCYPROMIN_UND_PSYCHOLEPTIKA)
            .andGroup(MedicationGroups.TCA, 50)
            .andGroup(MedicationGroups.SNRI),
        new MedicationAnswer("Ja").followedBy(
            //Ursprgl. Frage: "Hatte der Patient/die Patientin in den letzten 6 Monaten bzw.
            //  seit dem letzten Ausfüllen dieser Fragen über eine Tachykardie berichtet?";

            //Geändert zu v5: "Der Patient / die Patientin hat(te) eine Tachykardie in den letzten 6 Monaten?"
            PatientHasPreCondition(
                PatientPreConditions.v5,
                new MedicationAnswer("Ja").triggers([
                    MedicationIndicators.RISK_OF_UNWANTED_KARDIOVASKULAER_EFFECTS_3
                ])
            )(input)
        )
    )(input)

const SECTION_7: QuestionCreator = (input) =>
    PatientTakesMedicine(
        medSearch()
            .andGroup(MedicationGroups.BUPROPION_DRUGS)
            .and(SingleMedicationEntries.PAROXETIN)
            .and(SingleMedicationEntries.FLUOXETIN_UND_PSYCHOLEPTIKA)
            .and(SingleMedicationEntries.FLUOXETIN),
        new MedicationAnswer("Ja").followedBy(
            //Bekommt der Patient zusätzlich Metoprolol oder Propranolol?
            PatientTakesMedicine(
                medSearch()
                    .andGroup(MedicationGroups.METOPROLOL_DRUGS)
                    .andGroup(MedicationGroups.PROPANOLOL_DRUGS),
                new MedicationAnswer("Ja").triggers([
                    MedicationIndicators.RISK_OF_BARDYKARDIE
                ])
            )(input)
        )
    )(input)

const SECTION_8: QuestionCreator = (input) =>
    PatientTakesMedicine(
        medSearch()
            .andGroup(MedicationGroups.BUPROPION_DRUGS)
            .and(SingleMedicationEntries.TRANYLCYPROMIN)
            .and(SingleMedicationEntries.TRANYLCYPROMIN_UND_PSYCHOLEPTIKA)
            .andGroup(MedicationGroups.TCA, 50)
            .andGroup(MedicationGroups.SNRI),
        new MedicationAnswer("Ja").followedBy(
            //Ursprngl. Frage: "Hatte der Patient/die Patientin in den letzten 6 Monaten bzw.
            // seit dem letzten Ausfüllen dieser Fragen über eine unkontrollierte Hypertonie berichtet?";

            //Geändert zu v3: "Der Patient / die Patientin hat(te) eine unkontrollierte Hypertonie?"
            PatientHasPreCondition(
                PatientPreConditions.v3,
                new MedicationAnswer("Ja").triggers([
                    MedicationIndicators.RISK_OF_UNWANTED_KARDIOVASKULAER_EFFECTS_4
                ])
            )(input)
        )
    )(input)

const SECTION_9_A: QuestionCreator = (input) =>
    
    PatientTakesMedicine(
        medSearch()
            .andGroup(MedicationGroups.SNRI)
            .andGroup(MedicationGroups.BUPROPION_DRUGS)
            .and(SingleMedicationEntries.TRANYLCYPROMIN)
            .and(SingleMedicationEntries.TRANYLCYPROMIN_UND_PSYCHOLEPTIKA)
            .andGroup(MedicationGroups.TCA, 50),
        new MedicationAnswer("Ja").followedBy(
            //Nimmt der Patient/ die Patientin täglich ≥3 Medikamente zur Behandlung einer Hypertonie ein?
            PatientTakesMedicine(
                medSearch().andGroup(MedicationGroups.ANTIHYPERTENSIVE_DRUGS),
                new MedicationAnswer("Ja").triggers([
                    MedicationIndicators.RISK_OF_UNWANTED_KARDIOVASKULAER_EFFECTS_6
                ]),
                { strategy: BoolQuestionAnswerStrategy.ON_YES },
                3
            )(input)
        )
    )(input)

const SECTION_9_B: QuestionCreator = (input) =>
    PatientTakesMedicine(
        medSearch()
            .and(SingleMedicationEntries.TRAZODON)
            .and(SingleMedicationEntries.TRANYLCYPROMIN)
            .and(SingleMedicationEntries.TRANYLCYPROMIN_UND_PSYCHOLEPTIKA)
            .andGroup(MedicationGroups.TCA, 50),
        new MedicationAnswer("Ja").followedBy(
            PatientHasSFQValue(
                PatientSFQValues.v1,
                new MedicationAnswer("Ja").triggers([
                    MedicationIndicators.UNWANTED_MEDICATION_EFFECT_SCHWINDEL_2
                ])
            )(input)
        )
    )(input)

const SECTION_10: QuestionCreator = (input) =>
    PatientTakesMedicine(
        medSearch()
            .andGroup(MedicationGroups.SSRI)
            .and(SingleMedicationEntries.MIRTAZAPIN)
            .andGroup(MedicationGroups.SNRI),
        new MedicationAnswer("Ja").followedBy(
            PatientAgeIsAtLeast(
                65,
                new MedicationAnswer("Ja").followedBy(
                    PatientHasSFQValue(
                        PatientSFQValues.v1,
                        new MedicationAnswer("Ja").triggers([
                            MedicationIndicators.UNWANTED_MEDICATION_EFFECT_SCHWINDEL_1
                        ])
                    )(input)
                )
            )(input)
        )
    )(input)

const SECTION_11: QuestionCreator = (input) =>
    PatientTakesMedicine(
        medSearch()
            .andGroup(MedicationGroups.TCA, 50)
            .and(SingleMedicationEntries.TRAZODON)
            .and(SingleMedicationEntries.TRANYLCYPROMIN)
            .and(SingleMedicationEntries.TRANYLCYPROMIN_UND_PSYCHOLEPTIKA),
        new MedicationAnswer("Ja").followedBy(
            PatientAgeIsAtLeast(
                65,
                new MedicationAnswer("Ja").followedBy(
                    //Bekommt der Patient/ die Patientin ≥1 weiteres Medikament mit bekannter blutdrucksenkender Wirkung?
                    PatientTakesMedicine(
                        medSearch().andGroup(
                            MedicationGroups.FURTHER_ANTIHYPERTENSIVE_DRUGS
                        ),
                        new MedicationAnswer("Ja").triggers([
                            MedicationIndicators.UNWANTED_MEDICATION_EFFECT_SCHWINDEL_3
                        ])
                    )(input)
                )
            )(input)
        )
    )(input)

const SECTION_12: QuestionCreator = (
    input //Indicator 12
) =>
    PatientTakesMedicine(
        medSearch()
            .and(SingleMedicationEntries.TRAZODON)
            .and(SingleMedicationEntries.TRANYLCYPROMIN)
            .and(SingleMedicationEntries.TRANYLCYPROMIN_UND_PSYCHOLEPTIKA)
            .andGroup(MedicationGroups.TCA, 50),
        new MedicationAnswer("Ja").followedBy(
            PatientAgeIsAtLeast(
                65,
                new MedicationAnswer("Ja").followedBy(
                    PatientTakesMedicine(
                        medSearch().andGroup(
                            MedicationGroups.FURTHER_ANTIHYPERTENSIVE_DRUGS
                        ),
                        new MedicationAnswer("Ja").triggers([
                            MedicationIndicators.UNWANTED_MEDICATION_EFFECT_SCHWINDEL_3
                        ])
                    )(input)
                )
            )(input)
        )
    )(input)

const SECTION_13: QuestionCreator = (
    input //Indicator 13
) =>
    PatientTakesMedicine(
        medSearch()
            .andGroup(MedicationGroups.SSRI)
            .and(SingleMedicationEntries.MIRTAZAPIN)
            .andGroup(MedicationGroups.SNRI),
        new MedicationAnswer("Ja").followedBy(
            PatientAgeIsAtLeast(
                65,
                new MedicationAnswer("Ja").followedBy(
                    PatientTakesMedicine(
                        medSearch().andGroup(
                            MedicationGroups.FURTHER_ANTIHYPERTENSIVE_DRUGS
                        ),
                        new MedicationAnswer("Ja").triggers([
                            MedicationIndicators.UNWANTED_MEDICATION_EFFECT_SCHWINDEL_4
                        ]),
                        { strategy: BoolQuestionAnswerStrategy.ON_YES },
                        2
                    )(input)
                )
            )(input)
        )
    )(input)

const SECTION_14_A: QuestionCreator = (input) =>
    PatientAgeIsAtLeast(
        65,
        new MedicationAnswer("Ja").followedBy(
            PatientTakesMedicine(
                medSearch().andGroup(
                    MedicationGroups.FALL_RISK_INCREASING_DRUGS
                ),
                new MedicationAnswer("Ja").triggers([
                    MedicationIndicators.RISK_OF_FALL_3
                ])
            )(input)
        )
    )(input)

const SECTION_14_B: QuestionCreator = (input) =>
    PatientTakesAtLeastNumberOfAntidepressants(
        1,
        new MedicationAnswer("Ja").followedBy(
            PatientHasSFQValue(
                PatientSFQValues.v4,
                new MedicationAnswer("Ja").triggers([
                    MedicationIndicators.RISK_OF_REPEATED_FALL
                ])
            )(input)
        )
    )(input)

const SECTION_15_A: QuestionCreator = (input) =>
    PatientHasPreCondition(
        PatientPreConditions.v8,
        new MedicationAnswer("Ja").triggers([MedicationIndicators.RISK_OF_FALL])
    )(input)

const SECTION_15_B: QuestionCreator = (input) =>
    PatientHasPreCondition(
        PatientPreConditions.v10,
        new MedicationAnswer("Ja").triggers([MedicationIndicators.RISK_OF_FALL])
    )(input)

const SECTION_16: QuestionCreator = (input) =>
    PatientHasPreCondition(
        PatientPreConditions.v6,
        new MedicationAnswer("Ja").followedBy(
            //Bekommt der Patient/die Patientin ≥1 weiteres Medikament, das das Sturzrisiko erhöht?
            PatientTakesMedicine(
                medSearch().andGroup(
                    MedicationGroups.FALL_RISK_INCREASING_DRUGS
                ),
                new MedicationAnswer("Ja").triggers([
                    MedicationIndicators.RISK_OF_FALL_2
                ])
            )(input)
        )
    )(input)

const SECTION_17: QuestionCreator = (input) =>
    PatientTakesMedicine(
        medSearch()
            .and(SingleMedicationEntries.OPIPRAMOL)
            .andGroup(MedicationGroups.TCA, 50)
            .and(SingleMedicationEntries.PAROXETIN),
        new MedicationAnswer("Ja").followedBy(
            PatientHasPreCondition(
                PatientPreConditions.v10,
                new MedicationAnswer("Ja").triggers([
                    MedicationIndicators.RISK_OF_COGNITIVE_DISABILITY
                ])
            )(input)
        )
    )(input)

const SECTION_18: QuestionCreator = (input) =>
    PatientTakesMedicine(
        medSearch()
            .and(SingleMedicationEntries.OPIPRAMOL)
            .andGroup(MedicationGroups.TCA, 50)
            .and(SingleMedicationEntries.PAROXETIN),
        new MedicationAnswer("Ja").followedBy(
            //Hat der Patient/die Patientin bereits ein Delir erlitten?
            PatientHasPreCondition(
                PatientPreConditions.v9,
                new MedicationAnswer("Ja").followedBy(
                    PatientTakesMedicine(
                        medSearch().andGroup(
                            MedicationGroups.DELIRIUM_INDUCING_DRUGS
                        ),
                        new MedicationAnswer("Ja").triggers([
                            MedicationIndicators.RISK_OF_REPEATED_DELIR_1
                        ])
                    )(input)
                )
            )(input)
        )
    )(input)

const SECTION_19: QuestionCreator = (
    input //>=2 Delir Medikamente
) =>
    PatientTakesMedicine(
        medSearch()
            .and(SingleMedicationEntries.OPIPRAMOL)
            .andGroup(MedicationGroups.TCA, 50)
            .and(SingleMedicationEntries.PAROXETIN),
        new MedicationAnswer("Ja").followedBy(
            PatientAgeIsAtLeast(
                65,
                new MedicationAnswer("Ja").followedBy(
                    //Bekommt der Patient/ die Patientin ≥2 weitere Medikamente mit Risiko für Delir?
                    PatientTakesMedicine(
                        medSearch().andGroup(
                            MedicationGroups.DELIRIUM_INDUCING_DRUGS
                        ),
                        new MedicationAnswer("Ja").triggers([
                            MedicationIndicators.RISK_OF_REPEATED_DELIR_2
                        ]),
                        { strategy: BoolQuestionAnswerStrategy.ON_YES },
                        2
                    )(input)
                )
            )(input)
        )
    )(input)

const SECTION_20: QuestionCreator = (
    input //In Word Section 21
) =>
    PatientTakesMedicine(
        medSearch()
            .and(SingleMedicationEntries.TRANYLCYPROMIN)
            .and(SingleMedicationEntries.TRANYLCYPROMIN_UND_PSYCHOLEPTIKA),
        new MedicationAnswer("Ja").followedBy(
            //Bekommt der Patient/die Patientin ≥1 weiteres Medikament mit serotonerger Wirkung?
            PatientTakesMedicine(
                medSearch().andGroup(MedicationGroups.SEROTONERGIC_DRUGS),
                new MedicationAnswer("Ja").triggers([
                    MedicationIndicators.RISK_OF_SEROTONIN_SYNDROME_1
                ])
            )(input)
        )
    )(input)

const SECTION_21: QuestionCreator = (
    input //In Word Section 22
) =>
    PatientTakesMedicine(
        medSearch()
            .andGroup(MedicationGroups.SSRI)
            .andGroup(MedicationGroups.TCA, 50)
            .andGroup(MedicationGroups.SNRI),
        new MedicationAnswer("Ja").followedBy(
            PatientTakesMedicine(
                medSearch().andGroup(MedicationGroups.SEROTONERGIC_DRUGS),
                new MedicationAnswer("Ja").triggers([
                    MedicationIndicators.RISK_OF_SEROTONIN_SYNDROME_2
                ]),
                { strategy: BoolQuestionAnswerStrategy.ON_YES },
                3
            )(input)
        )
    )(input)

const SECTION_22: QuestionCreator = (input) =>
    PatientTakesMedicine(
        medSearch()
            .andGroup(MedicationGroups.SSRI)
            .andGroup(MedicationGroups.SNRI),
        new MedicationAnswer("Ja").followedBy(
            PatientAgeIsAtLeast(
                65,
                new MedicationAnswer("Ja").followedBy(
                    //Bekommt der Patient/die Patientin ≥1 weiteres Medikament aus der Gruppe der Thrombozytenaggregationshemmer,
                    // Antikoagulanzien oder NSAR, ohne dass ein GI-Schutz vorliegt?
                    PatientTakesMedicine(
                        medSearch().andGroup(
                            MedicationGroups.PPIS_OR_COMBINATIONS_WITH_PPIS
                        ),
                        new MedicationAnswer("Nein").followedBy(
                            PatientTakesMedicine(
                                medSearch().andGroup(
                                    MedicationGroups.RISK_OF_GASTROINTESTINAL_BLEEDING_NO_PPI_DRUGS
                                ),
                                new MedicationAnswer("Ja").triggers([
                                    MedicationIndicators.RISK_OF_GASTROINTESTINAL_BLOODING_2
                                ])
                            )(input)
                        ),
                        { strategy: BoolQuestionAnswerStrategy.ON_NO }
                    )(input)
                )
            )(input)
        )
    )(input)

const SECTION_23: QuestionCreator = (input) =>
    PatientTakesMedicine(
        medSearch()
            .andGroup(MedicationGroups.SSRI)
            .andGroup(MedicationGroups.SNRI),
        new MedicationAnswer("Ja").followedBy(
            PatientAgeIsAtLeast(
                65,
                new MedicationAnswer("Ja").followedBy(
                    //Bekommt der Patient/die Patientin ≥2 weitere Medikamente aus der Gruppe der Thrombozytenaggregationshemmer,
                    // Antikoagulanzien der NSAR (unabhängig von der GI-Protektion)?
                    PatientTakesMedicine(
                        medSearch().andGroup(
                            MedicationGroups.RISK_OF_GASTROINTESTINAL_BLEEDING_NO_PPI_DRUGS
                        ),
                        new MedicationAnswer("Ja").triggers([
                            MedicationIndicators.RISK_OF_GASTROINTESTINAL_BLOODING_3
                        ]),
                        { strategy: BoolQuestionAnswerStrategy.ON_YES },
                        2
                    )(input)
                )
            )(input)
        )
    )(input)

const SECTION_24: QuestionCreator = (input) =>
    PatientTakesMedicine(
        medSearch()
            .andGroup(MedicationGroups.SSRI)
            .andGroup(MedicationGroups.SNRI),
        new MedicationAnswer("Ja").followedBy(
            //Der Patient / die Patientin hat gastrointestinale Erkrankungen (Ulkus, Blutung, ...)?
            PatientHasPreCondition(
                PatientPreConditions.v16,
                new MedicationAnswer("Ja").followedBy(
                    PatientTakesMedicine(
                        medSearch().andGroup(
                            MedicationGroups.RISK_OF_GASTROINTESTINAL_BLEEDING_NO_PPI_DRUGS
                        ),
                        new MedicationAnswer("Ja").triggers([
                            MedicationIndicators.RISK_OF_GASTROINTESTINAL_BLOODING_1
                        ])
                    )(input)
                )
            )(input)
        )
    )(input)

const SECTION_25: QuestionCreator = (input) =>
    PatientTakesMedicine(
        medSearch().andGroup(MedicationGroups.SSRI),
        new MedicationAnswer("Ja").followedBy(
            PatientTakesMedicine(
                medSearch().andGroup(MedicationGroups.RISK_OF_BLEEDING_DRUGS),
                new MedicationAnswer("Ja").followedBy(
                    //Der Patient / die Patientin hatte bereits eine nicht-gastrointestinale Blutung erlitten?
                    PatientHasPreCondition(
                        PatientPreConditions.v18,
                        new MedicationAnswer("Ja").triggers([
                            MedicationIndicators.RISK_OF_BLOODING
                        ]),
                        {
                            strategy: BoolQuestionAnswerStrategy.ON_YES,
                            alternativeAnswer: new MedicationAnswer(
                                "Nein"
                            ).followedBy(
                                //Der Patient / die Patientin hat eine Demenz?
                                PatientHasPreCondition(
                                    PatientPreConditions.v8,
                                    new MedicationAnswer("Ja").triggers([
                                        MedicationIndicators.RISK_OF_BLOODING
                                    ]),
                                    {
                                        strategy:
                                            BoolQuestionAnswerStrategy.ON_YES,
                                        alternativeAnswer: new MedicationAnswer(
                                            "Nein"
                                        ).followedBy(
                                            PatientAgeIsAtLeast(
                                                65,
                                                new MedicationAnswer(
                                                    "Ja"
                                                ).triggers([
                                                    MedicationIndicators.RISK_OF_BLOODING
                                                ]),
                                                {
                                                    strategy:
                                                        BoolQuestionAnswerStrategy.ON_YES,
                                                    alternativeAnswer:
                                                        new MedicationAnswer(
                                                            "Nein"
                                                        ).followedBy(
                                                            PatientHasPreCondition(
                                                                PatientPreConditions.v6,
                                                                new MedicationAnswer(
                                                                    "Ja"
                                                                ).triggers([
                                                                    MedicationIndicators.RISK_OF_BLOODING
                                                                ])
                                                            )(input)
                                                        )
                                                }
                                            )(input)
                                        )
                                    }
                                )(input)
                            )
                        }
                    )(input)
                )
            )(input)
        )
    )(input)

const SECTION_26: QuestionCreator = (input) =>
    PatientTakesMedicine(
        medSearch()
            .andGroup(MedicationGroups.TCA, 50)
            .and(SingleMedicationEntries.PAROXETIN)
            .and(SingleMedicationEntries.OPIPRAMOL),
        new MedicationAnswer("Ja").followedBy(
            PatientHasSFQValue(
                PatientSFQValues.v2,
                new MedicationAnswer("Ja").triggers([
                    MedicationIndicators.UNWANTED_MEDICATION_EFFECT_VERSTOPFUNG
                ])
            )(input)
        )
    )(input)

const SECTION_27: QuestionCreator = (input) =>
    PatientTakesMedicine(
        medSearch()
            .andGroup(MedicationGroups.TCA, 50)
            .and(SingleMedicationEntries.PAROXETIN)
            .and(SingleMedicationEntries.OPIPRAMOL),
        new MedicationAnswer("Ja").followedBy(
            PatientAgeIsAtLeast(
                65,
                new MedicationAnswer("Ja").followedBy(
                    //Bekommt der Patient/ die Patientin ≥2 weitere Medikamente mit Risiko für Verstopfung?
                    PatientTakesMedicine(
                        medSearch().andGroup(
                            MedicationGroups.CONSTIPATING_EFECT_DRUGS
                        ),
                        new MedicationAnswer("Ja").triggers([
                            MedicationIndicators.RISK_OF_VERSTOPFUNG
                        ]),
                        { strategy: BoolQuestionAnswerStrategy.ON_YES },
                        2
                    )(input)
                )
            )(input)
        )
    )(input)

const SECTION_28: QuestionCreator = (input) =>
    //Der Patient / die Patientin hatte in den letzten 6 Monaten eine Hyponatriämie (<130 mmol/l)?
    PatientHasPreCondition(
        PatientPreConditions.v20,
        new MedicationAnswer("Ja").followedBy(
            //Nimmt der Patient/die Patientin kein Diuretikum ein?
            PatientTakesMedicine(
                medSearch().andGroup(MedicationGroups.DIURETICS),
                new MedicationAnswer("Nein").triggers([
                    MedicationIndicators.RISK_OF_HYPONATRIAEMIE_1
                ]),
                { strategy: BoolQuestionAnswerStrategy.ON_NO }
            )(input)
        )
    )(input)

const SECTION_29: QuestionCreator = (input) =>
    PatientAgeIsAtLeast(
        65,
        new MedicationAnswer("Ja").followedBy(
            PatientTakesMedicine(
                medSearch()
                    .andGroup(MedicationGroups.SSRI)
                    .andGroup(MedicationGroups.SNRI),
                new MedicationAnswer("Ja").followedBy(
                    //Bekommt der Patient/ die Patientin ≥2 weitere Medikamente mit Hyponatriämie-Risiko?
                    PatientTakesMedicine(
                        medSearch().andGroup(
                            MedicationGroups.HYPONATREMIA_CAUSING_DRUGS
                        ),
                        new MedicationAnswer("Ja").triggers([
                            MedicationIndicators.RISK_OF_RISK_OF_HYPONATRIAEMIE_2
                        ]),
                        { strategy: BoolQuestionAnswerStrategy.ON_YES },
                        3
                    )(input)
                )
            )(input)
        )
    )(input)

const SECTION_30_A: QuestionCreator = (input) =>
    PatientTakesMedicine(
        medSearch().and(SingleMedicationEntries.AGOMELATIN),
        new MedicationAnswer("Ja").followedBy(
            //Hat der Patient/die Patientin unter der Behandlung erhöhte Serumtransaminasewerte (>3-facher oberer Normalbereich) entwickelt?
            PatientHasPreCondition(
                PatientPreConditions.v21,
                new MedicationAnswer("Ja").triggers([
                    MedicationIndicators.RISK_OF_LIVER_DAMAGE_1
                ])
            )(input)
        )
    )(input)

const SECTION_30_B: QuestionCreator = (input) =>
    PatientTakesMedicine(
        medSearch().and(SingleMedicationEntries.AGOMELATIN),
        new MedicationAnswer("Ja").followedBy(
            //Der Patient / die Patientin hat eine Zirrhose oder aktive Lebererkrankung?
            PatientHasPreCondition(
                PatientPreConditions.v17,
                new MedicationAnswer("Ja").triggers([
                    MedicationIndicators.RISK_OF_LIVER_DAMAGE_2
                ])
            )(input)
        )
    )(input)

const SECTION_31: QuestionCreator = (input) =>
    PatientTakesMedicine(
        medSearch()
            .andGroup(MedicationGroups.TCA, 50)
            .and(SingleMedicationEntries.PAROXETIN)
            .and(SingleMedicationEntries.OPIPRAMOL),
        new MedicationAnswer("Ja").followedBy(
            //Der Patient / die Patientin hatte Miktionsstörungen (Harnverhalt, BPH, …) in den letzten 6 Monaten?
            PatientHasPreCondition(
                PatientPreConditions.v15,
                new MedicationAnswer("Ja").triggers([
                    MedicationIndicators.RISK_OF_REPEATED_HARNVERHALT
                ])
            )(input)
        )
    )(input)

const SECTION_32: QuestionCreator = (input) =>
    PatientTakesMedicine(
        medSearch()
            .andGroup(MedicationGroups.TCA, 50)
            .and(SingleMedicationEntries.PAROXETIN)
            .and(SingleMedicationEntries.OPIPRAMOL),
        new MedicationAnswer("Ja").followedBy(
            //Der Patient / die Patientin hatte ein Engwinkelglaukom in den letzten 6 Monaten?
            PatientHasPreCondition(
                PatientPreConditions.v19,
                new MedicationAnswer("Ja").triggers([
                    MedicationIndicators.RISK_OF_REPEATED_ENGWINKELGLAUKOM
                ])
            )(input)
        )
    )(input)

const SECTION_33: QuestionCreator = (input) =>
    PatientTakesMedicine(
        medSearch()
            .andGroup(MedicationGroups.SSRI)
            .andGroup(MedicationGroups.BUPROPION_DRUGS)
            .andGroup(MedicationGroups.MAOI)
            .andGroup(MedicationGroups.SNRI),
        new MedicationAnswer("Ja").followedBy(
            //Der Patient / die Patientin hatte Schlaflosigkeit oder Unruhe in den letzten 6 Monaten?
            PatientHasPreCondition(
                PatientPreConditions.v11,
                new MedicationAnswer("Ja").triggers([
                    MedicationIndicators.UNWANTED_MEDICATION_EFFECT_INSOMNIA
                ])
            )(input)
        )
    )(input)

const SECTION_34: QuestionCreator = (input) =>
    PatientTakesMedicine(
        medSearch()
            .andGroup(MedicationGroups.SSRI)
            .andGroup(MedicationGroups.SNRI),
        new MedicationAnswer("Ja").followedBy(
            PatientHasSFQValue(
                PatientSFQValues.v3,
                new MedicationAnswer("Ja").triggers([
                    MedicationIndicators.UNWANTED_MEDICATION_EFFECT_SEXUAL
                ])
            )(input)
        )
    )(input)

const RiskMedicationQuestionnaireBuilder: QuestionCreator[] = [
    SECTION_1,
    SECTION_2,
    SECTION_3,
    SECTION_4,
    SECTION_5,
    SECTION_6,
    SECTION_7,
    SECTION_8,
    SECTION_9_A,
    SECTION_9_B,
    SECTION_10,
    SECTION_11,
    SECTION_12,
    SECTION_13,
    SECTION_14_A,
    SECTION_14_B,
    SECTION_15_A,
    SECTION_15_B,
    SECTION_16,
    SECTION_17,
    SECTION_18,
    SECTION_19,
    SECTION_20,
    SECTION_21,
    SECTION_22,
    SECTION_23,
    SECTION_24,
    SECTION_25,
    SECTION_26,
    SECTION_27,
    SECTION_28,
    SECTION_29,
    SECTION_30_A,
    SECTION_30_B,
    SECTION_31,
    SECTION_32,
    SECTION_33,
    SECTION_34
]

export default RiskMedicationQuestionnaireBuilder
